import $ from 'jquery';
import axios from 'axios';

const isRoute = window.location.href.indexOf('/new-blog') !== -1;

const shareButtonUrl = '/rest/share/list';

export const newBlogHandlers = () => {
    if (!isRoute) {
        return;
    }

    $('.new-blog-post-list-more-button').on('click', function () {
        $('.new-blog-rest-post-list').removeClass('hidden');
        $(this).addClass('hidden');
    });

    $('.js-new-blog-load-share-buttons').each(function () {
        axios.post(shareButtonUrl, {
            url: $(this).data('link'),
            title: $(this).data('title')
        })
            .then((response) => {
                $(this).append(response.data.data);
            });
    });
};
